export default __webpack_public_path__ + "static/18-3dc523122206ce2f94d7aa15092c9eb5.jpg";